import React from 'react';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { articles } from '../data/blogArticles';
import { blogPosts, getBlogImage } from '../data/allBlogPosts';

// Toont de drie eerste blogartikelen. Dit zijn de praktische stukken op de
// vraag die een ondernemer daadwerkelijk in Google typt; de SEO-kennisbank
// staat een niveau dieper in de bibliotheek.
export const BlogSection: React.FC = () => {
  const featured = blogPosts.slice(0, 3);
  const totalItems = blogPosts.length + articles.length;
  return <section id="kennis" className="w-full bg-white py-20 md:py-24 scroll-mt-24" data-id="element-111" data-mp="1gp2njhvuj4zw">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-112" data-mp="11y3jmk5yh4mn">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12" data-id="element-113" data-mp="16w5b9thg6c9q">
          <div className="max-w-2xl" data-id="element-114" data-mp="1um94d6x0etmh">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1]
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-115" data-mp="1ul7sj086633p">
              Kennis waar je zelf mee vooruit kunt
            </motion.h2>
            <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-116" data-mp="108y76wki6fgn">
              Praktische stukken over vindbaarheid, websites en vormgeving,
              geschreven voor ondernemers in Noord-Holland Noord. Geen jargon,
              geen verkooppraat.
            </p>
          </div>
          <a href="/bibliotheek" className="inline-flex items-center gap-2 text-[#004AC7] font-semibold hover:text-[#003A9E] transition-colors duration-200 flex-shrink-0 group" data-id="element-117" data-mp="1nysekym1zbti">
            Alle {totalItems} artikelen
            <ArrowRightIcon className="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-118" data-mp="3ppnfu5z1437m" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-119" data-mp="1oo7ekflmjcfd">
          {featured.map((post, index) => <motion.a key={post.slug} href={`/blog/${post.slug}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-[#004AC7] transition-colors duration-200 flex flex-col" data-id="element-120" data-mp="1tn0qw4p6cxdy" data-mpi={index}>
              <div className="relative h-48 flex-shrink-0 overflow-hidden" data-id="element-121" data-mp="2hd4wghlxb77l">
                <img src={getBlogImage(post)} alt={`${post.title}, artikel van Noord Digital`} loading="lazy" className="w-full h-full object-cover" data-id="element-122" data-mp="2hf7jcsrs4k83" />
                <span className="absolute top-4 left-4 bg-[#004AC7] text-white text-xs font-semibold px-3 py-1 rounded-full" data-id="element-123" data-mp="2rc2hhak54ilu">
                  {post.category}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-124" data-mp="jqc344f4hiyu">
                <h3 className="font-bold text-[#111827] mb-3 text-xl leading-snug" data-id="element-125" data-mp="fnp9pz2szpzj">
                  {post.title}
                </h3>
                <p className="text-[#6B7280] mb-5 leading-relaxed flex-grow" data-id="element-126" data-mp="apnop8lthglf">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between mt-auto" data-id="element-127" data-mp="5rcfn03cja49">
                  <span className="inline-flex items-center gap-2 text-[#004AC7] font-semibold text-sm" data-id="element-128" data-mp="13byqunp2npkc">
                    Lees verder
                    <ArrowRightIcon className="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-129" data-mp="ygje5z2svzpi" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-xs text-[#6B7280]" data-id="element-130" data-mp="onufk4scmgbl">
                    <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-131" data-mp="1m5cdm5imspov" />
                    {post.readingTime} min
                  </span>
                </div>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
};